import SearchBar from '@components/util/SearchBar';
import React, { useEffect, useState } from 'react';
import { Card, Col, Pagination, Row } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { DeleteButton, EditButton } from '../../util/buttons';
import { useDispatch } from 'react-redux';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
import BusinessUnitEditForm from './BusinessUnitEditForm';
import * as QueryString from 'query-string';
import { useHistory } from 'react-router-dom';
const initialParams = 'page=1&query=&order_by=name asc';
const BusinessUnitsList = _ref => {
  let {
    company,
    setCompany,
    loading,
    setLoading,
    handleToaster,
    refreshFlag
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isEditing, setIsEditing] = useState(false);
  const [index, setIndex] = useState(null);
  const [bussinessUnitToEdit, setBusinessUnitToEdit] = useState({});
  const [bussinessUnits, setBussinesUnits] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [params, setParams] = useState(QueryString.parse(window.location.search || initialParams));
  useEffect(() => {
    const fetchBusinessUnits = async () => {
      setLoading(true);
      const response = await businessUnitsService.all(company.id, QueryString.stringify(params));
      setBussinesUnits(response.business_units || []);
      setTotalPages(response.pages);
      history.push({
        search: QueryString.stringify(params)
      });
      setLoading(false);
    };
    fetchBusinessUnits();
  }, [company.id, params, dispatch, history, setLoading, refreshFlag]);
  const deleteBu = async bu => {
    if (bu.project_business_units.length > 0) {
      handleToaster("You are trying to delete a Business Unit that has been assigned to a Project, please unassigned it from the Project to delete, otherwise set this Business Unit to 'Not Active' - thanks", 'warning');
    } else {
      if (window.confirm('Are you sure ?')) {
        try {
          setLoading(true);
          await businessUnitsService.delete(company.id, bu.id);
          const response = await businessUnitsService.all(company.id, QueryString.stringify(params));
          setBussinesUnits(response.business_units || []);
          setTotalPages(response.pages);
        } catch (e) {
          dispatch(handleError(e));
        } finally {
          setLoading(false);
        }
      }
    }
  };
  const handleSearch = query => {
    setParams({
      ...params,
      query,
      page: 1
    });
  };
  const handleSearchReset = () => {
    setParams({
      ...params,
      query: '',
      page: 1
    });
  };
  const handlePage = pageNumber => {
    setParams({
      ...params,
      page: pageNumber
    });
  };
  const sortBusinessUnits = (eventKey, direction, headerText) => {
    const orderByMap = {
      [t('business_unit')]: 'name',
      [t('state')]: 'state'
    };
    const orderBy = orderByMap[headerText];
    if (orderBy) {
      setParams({
        ...params,
        order_by: `${orderBy} ${direction}`
      });
    }
  };
  const headers = [{
    text: t('business_unit'),
    sortable: true,
    ...(params.order_by?.split(' ')[0] === 'name' && {
      order: params.order_by.split(' ')[1]
    })
  }, {
    text: t('state'),
    sortable: true,
    ...(params.order_by?.split(' ')[0] === 'state' && {
      order: params.order_by.split(' ')[1]
    })
  }, {
    text: ''
  }];
  const handleEdit = (bu, index) => {
    setIsEditing(true);
    setBusinessUnitToEdit(bu);
    setIndex(index);
  };
  const handleEditComplete = async () => {
    setIsEditing(false);
    const response = await businessUnitsService.all(company.id, QueryString.stringify(params));
    setBussinesUnits(response.business_units || []);
    setTotalPages(response.pages);
  };
  const rows = bussinessUnits?.map((bu, index) => {
    return {
      key: bu.id,
      columns: [bu.name, bu.state === 'active' ? 'Active' : 'Not Active', /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditButton, {
        onClick: () => handleEdit(bu, index)
      }), /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => deleteBu(bu)
      }))]
    };
  });
  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(/*#__PURE__*/React.createElement(Pagination.Item, {
      key: number,
      active: number === parseInt(params.page || 1),
      onClick: () => handlePage(number)
    }, number));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, "Business Unit Listing"), /*#__PURE__*/React.createElement(Card.Body, null, !isEditing && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 4,
      offset: 8
    }
  }, /*#__PURE__*/React.createElement(SearchBar, {
    onSubmit: handleSearch,
    onSearchReset: handleSearchReset,
    loading: loading,
    query: params.query,
    placeholder: t('search_business_units')
  }))), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onSort: (i, direction, headerText) => sortBusinessUnits(i, direction, headerText)
  })), isEditing && /*#__PURE__*/React.createElement(BusinessUnitEditForm, {
    setIsEditing: setIsEditing,
    bussinessUnitToEdit: bussinessUnitToEdit,
    setCompany: setCompany,
    company: company,
    loading: loading,
    setLoading: setLoading,
    index: index,
    onEditComplete: handleEditComplete
  }))), !isEditing && totalPages > 1 && /*#__PURE__*/React.createElement(Pagination, {
    className: "justify-content-end mt-3"
  }, paginationItems));
};
export default BusinessUnitsList;